import type { FaireProductEntity } from "../../entity_types/product";

export const p_knprc9hyn3: FaireProductEntity = {
  token: "p_knprc9hyn3",
  type: "product",
  name: 'Large Slouchy Hobo Tote-24x24"H',
  brandToken: "b_a8n58zvndo",
  brandName: "Abbott",
  imageUrl:
    "https://cdn.faire.com/fastly/43723c765beb18988a8d0842d4b324e8c6827fc7940d8184653118a3cc451c60.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/6527f327caff6fe9fbd1ba9d859725ee90479f12006a8ce0b88b2aa70e5876e6.jpeg",
    "https://cdn.faire.com/fastly/c9c5760b79bb6a0767dc9addd6ceda2b0575cd4ed145ab7da3dec9aecd40e191.jpeg",
    "https://cdn.faire.com/fastly/7c2e5a6d0398b241e83e19bd21c3d49d3b4a9384ab3988efbab9cb6a360b599e.jpeg",
    "https://cdn.faire.com/fastly/9f4f4995c6a65e8bcebc070b63d8c5c2a12770564a83dd7ae5dbf4f1336e4940.jpeg",
    "https://cdn.faire.com/fastly/e521275795bebad5c9a490076cdba759fd6de69f0982ab7f2b1013879b9f5293.jpeg",
    "https://cdn.faire.com/fastly/ae5d73df4b552be8db881095cb96818cbf52839f403e6fce9440bd72af029d8d.jpeg",
    "https://cdn.faire.com/fastly/8f1acc3328dc8477cc6538dcd7fe26ff9de9eb9cee09a7129bc2ef5dbfa8e90d.jpeg",
    "https://cdn.faire.com/fastly/31e1ed0611e8f25f14bc261f26917d5253653a6f71fdc33f69827929b42b3080.jpeg",
    "https://cdn.faire.com/fastly/99f521be7b884c6051cbec99d54b1e7a7c6057b3e09a3fdeff48dedc03ff8eb0.jpeg",
    "https://cdn.faire.com/fastly/5318c358f3afd7a321d3a27f967f1adcab7a1eed1ed07c5bc4a9e865babd9345.jpeg",
    "https://cdn.faire.com/fastly/eac7fffbd5c3c5667e6a9da60c348817b8845cfb0bb2516fe761342077c99bc4.jpeg",
    "https://cdn.faire.com/fastly/e35cbffb1935fc3d7ffdb4e9bd752c28dd5cfdb4ee10081671b1d3a61a5fcde8.jpeg",
    "https://cdn.faire.com/fastly/0dfb9b893771cee3538fb1c91bddb4ab6aabafbdadb5ef69416d2b66019a7ccf.jpeg",
  ],
  priceDollars: 35,
  description:
    "Crafted from durable cotton canvas, this generously sized tote features a relaxed silhouette and a wide shoulder strap for easy carrying.  Spacious and comfortable to wear, it transitions easily from errands to travel.",
  tags: [],
  msrpDollars: 70,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-05-06T19:58:07.279Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
